import {  addMinutes } from 'date-fns';

// Function to group bookings by date, time range, and booking type
import { formatInTimeZone } from 'date-fns-tz'; 

export const GroupBookingsByDateAndTimeRange = (bookingsArray, getBookingDetail, answersData, timezone) => {
  const groupedByDate = {};

  // Loop through bookings to group them
  bookingsArray.forEach(({ date, bookings }) => {
    // Parse the main booking date and convert to Pacific time
    const bookingDate = new Date(date);
    if (isNaN(bookingDate.getTime())) {
      console.error('Invalid booking date:', date);
      return; // Skip if the date is invalid
    }

    // Format the booking date in Pacific time (e.g., "Thursday, April 03 2025")
      const formattedDate = formatInTimeZone(bookingDate, timezone, 'EEEE, MMMM dd yyyy');

    // Initialize the date grouping if it doesn't exist
    if (!groupedByDate[formattedDate]) {
      groupedByDate[formattedDate] = {};
    }

    // Convert bookings set/array to an array
    const bookingsArrayLocal = Array.from(bookings);

    bookingsArrayLocal.forEach((booking) => {
      const parentBookingType = getBookingDetail(booking); // Get booking type details
      const bookingTypeTitle = booking.bookingTypeName; // Get the booking type name

      // Validate and parse the booking's time (from UTC)
      const bookingTime = new Date(booking.time);
      if (isNaN(bookingTime.getTime())) {
        console.error('Invalid booking time for booking ID:', booking.id, 'Time:', booking.time);
        return; // Skip if the booking time is invalid
      }

      const bookingLength = booking.duration;

      // Convert and format booking time to Pacific time using formatInTimeZone
        const currentStartTime = formatInTimeZone(bookingTime, timezone, 'hh:mm a'); // e.g., "06:00 pm"
      const currentEndTime = formatInTimeZone(
        addMinutes(bookingTime, bookingLength),
          timezone,
        'hh:mm a'
      ); // e.g., "08:00 pm"

      // Create a time range key using the formatted times
      const timeRangeKey = `${currentStartTime} - ${currentEndTime}`;

      // Initialize the time range grouping if it doesn't exist
      if (!groupedByDate[formattedDate][timeRangeKey]) {
        groupedByDate[formattedDate][timeRangeKey] = {};
      }

      // Initialize the booking type grouping if it doesn't exist
      if (!groupedByDate[formattedDate][timeRangeKey][bookingTypeTitle]) {
        groupedByDate[formattedDate][timeRangeKey][bookingTypeTitle] = {
          color: booking.bookingTypeColor,
          count: 0,
          bookings: [],
        };
      }

      // Increment count and add booking details
      groupedByDate[formattedDate][timeRangeKey][bookingTypeTitle].count += 1;
      groupedByDate[formattedDate][timeRangeKey][bookingTypeTitle].bookings.push({
        booking,
        parentBookingType,
        answer: answersData.getBookingAnswers?.find(answer => answer.bookingId === booking.id)?.answer || '',
      });
    });
  });

  return groupedByDate;
};

